@if (!shownFilterSet || shownFilterSet.has('text')) {
  <div class="filter-bar">
    <input type="text" pInputText placeholder="Filter activities" [(ngModel)]="filterText" (ngModelChange)="filterChanged()"/>
    <div class="filter-icon" [ngClass]="{'filters-active': filtersActive}">
      <fa-icon (click)="toggleShowFilters()" [icon]="faFilter"></fa-icon>
    </div>
  </div>
}
@if ((shownFilterSet && !shownFilterSet.has('text')) || showFilters) {
  <div class="filter-bar">
    @if (hasShownFilter('testObject')) {
      <div class="filter">
        <p-multi-select [options]="availableTestObjects" [(ngModel)]="selectedTestObjects" defaultLabel="Test Object" (onChange)="filterChanged()">
          <ng-template pTemplate="selectedItems">
            <span>Test Object</span>
            <!--        <span *ngIf="selectedTestObjects.length === 0">Objects</span>-->
            <!--        <span *ngIf="selectedTestObjects.length !== 0">Objects: {{ getLabelForSelectedTestObjects() }}</span>-->
          </ng-template>
        </p-multi-select>
      </div>
    }
    @if (!shownFilterSet || shownFilterSet.has('tag')) {
      <div class="filter">
        <p-multi-select [options]="availableTags" [(ngModel)]="selectedTags" defaultLabel="Tags" (onChange)="filterChanged()">
          <ng-template let-tag pTemplate="item">
            <wm-tags [onlyread]="true" [tags]="[tag.value]"></wm-tags>
          </ng-template>
          <ng-template pTemplate="selectedItems">
            <span>Tag</span>
            <!--        <span *ngIf="selectedTags.length === 0">Tags</span>-->
            <!--        <span *ngIf="selectedTags.length !== 0">Tags: {{ getLabelForSelectedTags() }}</span>-->
          </ng-template>
        </p-multi-select>
      </div>
    }
    @if (!shownFilterSet || shownFilterSet.has('executionStatus')) {
      <div class="filter">
        <p-multi-select [options]="availableExecutionStatuses" [(ngModel)]="selectedExecutionStatuses" defaultLabel="Status" (onChange)="filterChanged()">
          <ng-template pTemplate="selectedItems">
            <span>Status</span>
            <!--        <span *ngIf="selectedExecutionStatuses.length === 0">Status</span>-->
            <!--        <span *ngIf="selectedExecutionStatuses.length !== 0">Status: {{ getLabelForSelectedExecutionStatuses() }}</span>-->
          </ng-template>
        </p-multi-select>
      </div>
    }
    @if (!shownFilterSet || shownFilterSet.has('evaluationStatus')) {
      <div class="filter">
        <p-multi-select [options]="availableEvaluationStatuses" [(ngModel)]="selectedEvaluationStatuses" placeholder="Result" (onChange)="filterChanged()">
          <ng-template pTemplate="selectedItems">
            <span>Result</span>
            <!--        <span *ngIf="selectedEvaluationStatuses.length === 0">Result</span>-->
            <!--        <span *ngIf="selectedEvaluationStatuses.length !== 0">Result: {{ getLabelForSelectedEvaluationStatuses() }}</span>-->
          </ng-template>
        </p-multi-select>
      </div>
    }
  </div>

}

@if (((shownFilterSet && !shownFilterSet.has('text')) || showFilters)) {
  <div class="filter-bar">
    @if (hasShownFilter('results')) {
      <div class="filter">
        <p-checkbox id="showWithResults" inputId="showWithResults" name="showWithResults" [(ngModel)]="showWithResults" (ngModelChange)="filterChanged()" [binary]="true"></p-checkbox>
        <label for="showWithResults">Show activities with results</label>
      </div>
    }
  </div>
}
@if (!hideFiltersDisplay && showFilters) {
  <div class="filters-display filter-bar">
    @if ((selectedTags || []).length > 0) {
      <div class="filter-display-group">
        <div class="filter-group-name">Tags</div>
        @for (t of selectedTags; track t; let i = $index) {
          <div class="filter-entry">
            {{ tagToString(t) }}
          </div>
        }
      </div>
    }
    @if ((selectedExecutionStatuses || []).length > 0) {
      <div class="filter-display-group">
        <div class="filter-group-name">Status</div>
        @for (t of selectedExecutionStatuses; track t; let i = $index) {
          <div class="filter-entry">
            {{ t }}
          </div>
        }
      </div>
    }
    @if ((selectedEvaluationStatuses || []).length > 0) {
      <div class="filter-display-group">
        <div class="filter-group-name">Result</div>
        @for (t of selectedEvaluationStatuses; track t; let i = $index) {
          <div class="filter-entry">
            {{ t }}
          </div>
        }
      </div>
    }
    @if ((selectedTestObjects || []).length > 0) {
      <div class="filter-display-group">
        <div class="filter-group-name">Test Object</div>
        @for (t of selectedTestObjects; track t; let i = $index) {
          <div class="filter-entry">
            {{ testObjectsById[t]?.target?.name || statesByTestObjectId[t]?.name || t }}
          </div>
        }
      </div>
    }
  </div>
}
